import type { ExtensionType } from '@blocksuite/store';

import { FootNoteInlineSpecExtension } from './inline-spec';

export const inlineFootnoteExtensions: ExtensionType[] = [
  FootNoteInlineSpecExtension,
];
